import React, { Component } from 'react';
import Background from '../Background/Background';
import Welcome from '../../components/Welcome/Welcome';
import HomePage from "../../components/HomePage/HomePage";
import store from 'store';

function AccountAction () {
    
    const isLoggedIn = store.get("isLoggedIn");
    if(isLoggedIn){
        return <HomePage/>;
    }else{
        return (
            <Background>
                <Welcome/>

            </Background>

        )
    }
}

export default AccountAction;